import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aea0f2f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-3 ml-4" }
const _hoisted_2 = {
  key: 0,
  class: "validation-msg error"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Maximum file size: 50MB", -1))
const _hoisted_5 = { class: "file-list mb-2" }
const _hoisted_6 = { class: "file-name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-pdf" }, null, -1))
const _hoisted_8 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_Popover = _resolveComponent("Popover")
  const _component_FileDragAndDrop = _resolveComponent("FileDragAndDrop")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["file-uploader", {'answered': _ctx.validForm(), 'optional': _ctx.isFileUploadOptional}])
  }, [
    _createElementVNode("h4", null, [
      _createTextVNode(_toDisplayString(_ctx.newWording) + " ", 1),
      _createVNode(_component_Popover, { popover: _ctx.obj }, null, 8, ["popover"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FileDragAndDrop, {
        disabled: false,
        uploading: _ctx.uploading,
        ref: "fileDropAndDrop",
        onFileInputChanged: _cache[0] || (_cache[0] = $event => (_ctx.fileInputChanged($event))),
        numFileLimit: 5,
        fileSizeLimit: 50
      }, null, 8, ["uploading"]),
      (_ctx.question?.responses?.length == 0 && !_ctx.isFileUploadOptional)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(" File required. ")
          ]))
        : _createCommentVNode("", true),
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.responses, (f) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(f.wording), 1)
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline sml",
            onClick: $event => (_ctx.deleteFile(f.answerNumber))
          }, "Delete", 8, _hoisted_8)
        ]))
      }), 256))
    ]),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmDeleteDialogue",
      modalOpened: true
    }, null, 512)
  ], 2))
}